const registry = new Map();

export function registerModule(name, loader) {
  registry.set(name, loader);
}

export async function initModules(root = document) {
  const elements = root.querySelectorAll('[data-module]');

  await Promise.all(Array.from(elements).map(async (element) => {
    const names = element.dataset.module
      .split(/[\s,]+/)
      .map((name) => name.trim())
      .filter(Boolean);

    const initialized = new Set(
      (element.dataset.moduleInitialized || '')
        .split(/[\s,]+/)
        .filter(Boolean),
    );

    for (const name of names) {
      if (initialized.has(name) || !registry.has(name)) {
        continue;
      }

      const init = await registry.get(name)();
      if (typeof init === 'function') {
        init(element);
      }

      initialized.add(name);
      element.dataset.moduleInitialized = Array.from(initialized).join(' ');
    }
  }));
}

registerModule('code-copy', () => import('../modules/code-copy.js').then((module) => module.initCodeCopy));
registerModule('reviews', () => import('../modules/reviews.js').then((module) => module.initReviews));
registerModule('tabs', () => import('../modules/tabs.js').then((module) => module.initTabs));
registerModule('slider', () => import('../modules/sliders.js').then((module) => module.initSliders));
registerModule('home-slider', () => import('../modules/home-slider.js').then((module) => module.initHomeSlider));
registerModule('map', () => import('../modules/map.js').then((module) => module.initYandexMap));
registerModule('forms', () => import('../modules/forms.js').then((module) => module.initForms));
registerModule('cases', () => import('../modules/cases.js').then((module) => module.initCasesAjax));
registerModule('likes', () => import('../modules/likes.js').then((module) => module.initLikes));
registerModule('price-toggle', () => import('../modules/price-toggle.js').then((module) => module.initPriceToggle));
